export default __webpack_public_path__ + "static/media/9d40e44fd686a6d3.7111e451f49c9e79ef5dfd6f173e2829.svg";